export default __webpack_public_path__ + "static/media/image-31.c9cf0910.png";